"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _ListFilter = _interopRequireDefault(require("@/components/ListFilter"));
var _paginationEffect = _interopRequireDefault(require("@/utils/paginationEffect"));
var _filterConfig = _interopRequireDefault(require("./filterConfig.js"));
var _api = require("../api");
var _PackageDetail = _interopRequireDefault(require("./modules/PackageDetail.vue"));
var _AddCouponDialog = _interopRequireDefault(require("./modules/AddCouponDialog.vue"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _regenerator() { /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */ var e, t, r = "function" == typeof Symbol ? Symbol : {}, n = r.iterator || "@@iterator", o = r.toStringTag || "@@toStringTag"; function i(r, n, o, i) { var c = n && n.prototype instanceof Generator ? n : Generator, u = Object.create(c.prototype); return _regeneratorDefine2(u, "_invoke", function (r, n, o) { var i, c, u, f = 0, p = o || [], y = !1, G = { p: 0, n: 0, v: e, a: d, f: d.bind(e, 4), d: function d(t, r) { return i = t, c = 0, u = e, G.n = r, a; } }; function d(r, n) { for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) { var o, i = p[t], d = G.p, l = i[2]; r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0)); } if (o || r > 1) return a; throw y = !0, n; } return function (o, p, l) { if (f > 1) throw TypeError("Generator is already running"); for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) { i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u); try { if (f = 2, i) { if (c || (o = "next"), t = i[o]) { if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object"); if (!t.done) return t; u = t.value, c < 2 && (c = 0); } else 1 === c && (t = i.return) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1); i = e; } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break; } catch (t) { i = e, c = 1, u = t; } finally { f = 1; } } return { value: t, done: y }; }; }(r, o, i), !0), u; } var a = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} t = Object.getPrototypeOf; var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2(t = {}, n, function () { return this; }), t), u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c); function f(e) { return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2(u), _regeneratorDefine2(u, o, "Generator"), _regeneratorDefine2(u, n, function () { return this; }), _regeneratorDefine2(u, "toString", function () { return "[object Generator]"; }), (_regenerator = function _regenerator() { return { w: i, m: f }; })(); }
function _regeneratorDefine2(e, r, n, t) { var i = Object.defineProperty; try { i({}, "", {}); } catch (e) { i = 0; } _regeneratorDefine2 = function _regeneratorDefine(e, r, n, t) { function o(r, n) { _regeneratorDefine2(e, r, function (e) { return this._invoke(r, n, e); }); } r ? i ? i(e, r, { value: n, enumerable: !t, configurable: !t, writable: !t }) : e[r] = n : (o("next", 0), o("throw", 1), o("return", 2)); }, _regeneratorDefine2(e, r, n, t); }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, e) { if ("object" != _typeof(t) || !t) return t; var r; if ("undefined" != typeof Symbol && void 0 !== (r = t[Symbol.toPrimitive])) { var i = r.call(t, e || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === e ? String : Number)(t); } //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = exports.default = {
  components: {
    ListFilter: _ListFilter.default,
    PackageDetail: _PackageDetail.default,
    AddCouponDialog: _AddCouponDialog.default
  },
  data: function data() {
    return _objectSpread(_objectSpread({
      listLoading: false,
      tableData: {
        list: [],
        total: 0
      },
      tableFrom: {},
      detailDialogVisible: false,
      addEditDialogVisible: false,
      currentPackageId: null,
      isAdd: true,
      submitLoading: false,
      formData: {
        packageName: '',
        description: '',
        packageValue: 0
      },
      formRules: {
        packageName: [{
          required: true,
          message: '请输入券包名称',
          trigger: 'blur'
        }, {
          min: 2,
          max: 50,
          message: '长度在 2 到 50 个字符',
          trigger: 'blur'
        }],
        packageValue: [{
          required: true,
          message: '请输入券包价值',
          trigger: 'blur'
        }],
        description: [{
          max: 200,
          message: '长度不能超过 200 个字符',
          trigger: 'blur'
        }]
      },
      searchForm: {
        packageName: '',
        dateRange: [],
        createdAtStart: '',
        createdAtEnd: ''
      },
      datePickerOptions: {
        shortcuts: [{
          text: '最近一周',
          onClick: function onClick(picker) {
            var end = new Date();
            var start = new Date();
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
            picker.$emit('pick', [start, end]);
          }
        }, {
          text: '最近一个月',
          onClick: function onClick(picker) {
            var end = new Date();
            var start = new Date();
            start.setMonth(start.getMonth() - 1);
            picker.$emit('pick', [start, end]);
          }
        }, {
          text: '最近三个月',
          onClick: function onClick(picker) {
            var end = new Date();
            var start = new Date();
            start.setMonth(start.getMonth() - 3);
            picker.$emit('pick', [start, end]);
          }
        }]
      }
    }, (0, _filterConfig.default)({
      handleSearch: this.handleSearch
    })), (0, _paginationEffect.default)(this.handlerGetListData));
  },
  created: function created() {
    this.getList();
  },
  methods: {
    getList: function getList() {
      var _this = this;
      this.listLoading = true;
      var params = {
        page: this.pageData.page,
        limit: this.pageData.limit,
        packageName: this.searchForm.packageName,
        createdAtStart: this.searchForm.createdAtStart,
        createdAtEnd: this.searchForm.createdAtEnd
      };
      (0, _api.couponPackageListApi)(params).then(function (res) {
        if (res) {
          _this.tableData.list = (res.list || []).map(function (item) {
            return _objectSpread(_objectSpread({}, item), {}, {
              couponCount: item.couponCount || 0,
              packageValue: item.packageValue || 0
            });
          });
          _this.tableData.total = res.total;
          _this.pageData.page = res.page;
          _this.pageData.limit = res.limit;
        } else {
          _this.tableData.list = [];
          _this.tableData.total = 0;
        }
        _this.listLoading = false;
      }).catch(function () {
        _this.listLoading = false;
      });
    },
    handleDateRangeChange: function handleDateRangeChange(val) {
      if (val) {
        this.searchForm.createdAtStart = val[0];
        this.searchForm.createdAtEnd = val[1];
      } else {
        this.searchForm.createdAtStart = '';
        this.searchForm.createdAtEnd = '';
      }
    },
    openAddEditDialog: function openAddEditDialog(type, row) {
      var _this2 = this;
      this.isAdd = type === 'ADD';
      this.addEditDialogVisible = true;
      this.resetForm();
      if (!this.isAdd && row) {
        this.currentPackageId = row.id;

        // 获取详情
        (0, _api.couponPackageDetailApi)(row.id).then(function (res) {
          if (res && res) {
            _this2.formData = {
              id: res.id,
              packageName: res.packageName,
              description: res.description,
              packageValue: res.packageValue || 0
            };
          }
        });
      }
    },
    resetForm: function resetForm() {
      this.formData = {
        packageName: '',
        description: '',
        packageValue: 0
      };
      if (this.$refs.packageForm) {
        this.$refs.packageForm.clearValidate();
      }
    },
    resetSearch: function resetSearch() {
      this.searchForm = {
        packageName: '',
        dateRange: [],
        createdAtStart: '',
        createdAtEnd: ''
      };
      this.handleSearch();
    },
    handleAddEditDialogClose: function handleAddEditDialogClose() {
      this.addEditDialogVisible = false;
      this.resetForm();
      this.currentPackageId = null;
    },
    submitPackageForm: function submitPackageForm() {
      var _this3 = this;
      this.$refs.packageForm.validate(function (valid) {
        if (valid) {
          _this3.submitLoading = true;
          var requestData = {
            packageName: _this3.formData.packageName,
            description: _this3.formData.description,
            packageValue: _this3.formData.packageValue
          };
          if (_this3.isAdd) {
            // 创建券包
            (0, _api.createCouponPackageApi)(requestData).then(function (res) {
              if (res) {
                _this3.$message.success('新增券包成功');
                _this3.addEditDialogVisible = false;
                _this3.getList();
              }
              _this3.submitLoading = false;
            }).catch(function () {
              _this3.submitLoading = false;
            });
          } else {
            // 更新券包
            requestData.id = _this3.formData.id;
            (0, _api.updateCouponPackageApi)(_this3.currentPackageId, requestData).then(function (res) {
              if (res) {
                _this3.$message.success('更新券包成功');
                _this3.addEditDialogVisible = false;
                _this3.getList();
              }
              _this3.submitLoading = false;
            }).catch(function () {
              _this3.submitLoading = false;
            });
          }
        }
      });
    },
    getCurrentPackageName: function getCurrentPackageName() {
      var _this4 = this;
      if (!this.currentPackageId) return '';
      var currentPackage = this.tableData.list.find(function (item) {
        return item.id === _this4.currentPackageId;
      });
      return currentPackage ? currentPackage.packageName : '';
    },
    viewPackageCoupons: function viewPackageCoupons(row) {
      this.currentPackageId = row.id;
      this.detailDialogVisible = true;
    },
    handleDetailDialogClose: function handleDetailDialogClose() {
      this.detailDialogVisible = false;
      this.currentPackageId = null;
    },
    addCouponToPackage: function addCouponToPackage(packageId) {
      this.$refs.addCouponDialog.open(packageId);
    },
    refreshPackageDetail: function refreshPackageDetail() {
      // 刷新券包详情
      this.$bus.$emit('refreshPackageDetail');
      // 刷新券包列表以更新券包数据
      this.getList();
    },
    handlerDelete: function () {
      var _handlerDelete = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee(row) {
        var _this5 = this;
        var _t;
        return _regenerator().w(function (_context) {
          while (1) switch (_context.p = _context.n) {
            case 0:
              if (row.canDelete) {
                _context.n = 1;
                break;
              }
              return _context.a(2, this.$message.error('该券包下存在优惠券，无法删除'));
            case 1:
              _context.p = 1;
              _context.n = 2;
              return this.$confirm('确定删除当前券包?', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
              });
            case 2:
              this.listLoading = true;
              (0, _api.deleteCouponPackageApi)(row.id).then(function (res) {
                if (res) {
                  _this5.$message.success('删除成功');
                  _this5.getList();
                } else {
                  _this5.$message.error(res.message || '删除失败');
                  _this5.listLoading = false;
                }
              }).catch(function () {
                _this5.listLoading = false;
              });
              _context.n = 4;
              break;
            case 3:
              _context.p = 3;
              _t = _context.v;
            case 4:
              return _context.a(2);
          }
        }, _callee, this, [[1, 3]]);
      }));
      function handlerDelete(_x) {
        return _handlerDelete.apply(this, arguments);
      }
      return handlerDelete;
    }(),
    handleSearch: function handleSearch() {
      this.resetPageData();
      this.getList();
    },
    handlerGetListData: function () {
      var _handlerGetListData = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee2() {
        return _regenerator().w(function (_context2) {
          while (1) switch (_context2.n) {
            case 0:
              this.getList();
            case 1:
              return _context2.a(2);
          }
        }, _callee2, this);
      }));
      function handlerGetListData() {
        return _handlerGetListData.apply(this, arguments);
      }
      return handlerGetListData;
    }(),
    formatCurrency: function formatCurrency(value) {
      if (value === undefined || value === null) return '¥0.00';
      return '¥' + parseFloat(value).toFixed(2);
    }
  }
};